<template>
  <PageView :main-title="title" :no-sub-title-expected="true">
    <ContentView>
      <GraeDetailsView :active-tab="activeSubTab" />
    </ContentView>
  </PageView>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import PageView from "@/views/commons/PageView.vue"
import ContentView from "@/views/commons/ContentView.vue"
import GraeDetailsView from "@/views/grae/GraeDetailsView.vue"

import { LoginService } from "@/services/rest/login/LoginService"

export default defineComponent({
  name: "AEPage",
  components: {
    PageView,
    ContentView,
    GraeDetailsView,
  },
  props: {
    activeSubTab: Number,
  },
  data() {
    return {
      loginService: LoginService.INSTANCE,
      title: "",
    }
  },
  created(): void {
    const loggedUser = this.loginService.getLoggedUser()
    if (!loggedUser || !loggedUser.id) {
      return
    }
    this.title = this.$t(`menu.aires-educatives`).toString()
  },
})
</script>
